import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </ReactLenis>
      </LanguageProvider>
    </div>
  );
}

export default App;
